import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import {
  CreateJobProcessSuccess,
  LoadJobProcess,
  LoadJobProcessSuccess,
  ProcessActionTypes,
  UpdateJobProcess,
  UpdateJobProcessSuccess,
} from '../actions/process.actions';
import {
  concatMap,
  map,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import { ProcessService } from '../../../lib/services/processService';
import { AppState } from '../../../app.service';
import { select, Store } from '@ngrx/store';
import { selectProcess } from '../selectors/process.selectors';
import { of } from 'rxjs';

@Injectable()
export class ProcessEffects {
  @Effect()
  loadAllSteps$ = this.actions$.pipe(
    ofType<LoadJobProcess>(ProcessActionTypes.LOAD_JOB_PROCESS),
    mergeMap(action =>
      this.processService.fetchProcessSteps(action.payload.jobId)
    ),
    map(process => new LoadJobProcessSuccess({ process: process }))
  );

  @Effect()
  saveAllSteps$ = this.actions$.pipe(
    ofType<UpdateJobProcess>(ProcessActionTypes.UPDATE_JOB_PROCESS),
    map(action => action.payload),
    concatMap(action =>
      of(action).pipe(withLatestFrom(this.store$.pipe(select(selectProcess))))
    ),
    switchMap(([payload, state]) => {
      return this.processService.postProcessSteps(payload.jobId, state).pipe(
        map(
          result =>
            new UpdateJobProcessSuccess({
              process: result,
            })
        )
      );
    })
  );

  @Effect()
  createJobProcess$ = this.actions$.pipe(
    ofType<UpdateJobProcess>(ProcessActionTypes.CREATE_JOB_PROCESS),
    map(action => action.payload),
    switchMap(payload => {
      return this.processService.postProcessSteps(payload.jobId).pipe(
        map(
          result =>
            new CreateJobProcessSuccess({
              process: result,
            })
        )
      );
    })
  );

  constructor(
    private actions$: Actions,
    private processService: ProcessService,
    private store$: Store<AppState>
  ) {}
}
